/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Snap_To_Shot_ChangesInputs */



/**
* | output |
* | --- |
* | "Snap to Shot Changes" |
*
* @param {Options_Editor_Snap_To_Shot_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_snap_to_shot_changes = /** @type {((inputs?: Options_Editor_Snap_To_Shot_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Snap_To_Shot_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner sur les changements de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schnappschuss-Änderungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggancia alle modifiche di ripresa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменения при мгновенном переходе к кадру")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambios en la toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照到拍摄变化")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの変更にスナップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तनों पर स्नैप करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterações de disparo instantâneo")
	return /** @type {LocalizedString} */ ("Snap to Shot Changes")
});